<template>
<transition name="fade">
  <div class="content" v-if="show">
    <slider animation="normal" :auto="true" height="900px">
      <slider-item>
          <img class="sliderImage" src="../assets/img/slider.png" width="100%">
      </slider-item>
      <slider-item>
          <img class="sliderImage" src="../assets/img/slider2.jpg" width="100%">
      </slider-item>
      <slider-item>
          <img class="sliderImage" src="../assets/img/slider3.jpg" width="100%">
      </slider-item>
      <slider-item>
          <img class="sliderImage" src="../assets/img/slider4.jpg" width="100%">
      </slider-item>
    </slider>
    <div class="mt-5">
      <b-container class="bv-example-row bv-example-row-flex-cols">
        <b-row class="justify-content-md-center textCentred">
          <b-col cols="12" sm="12" md="12" lg="12" align-v="center">
          <img src="../assets/img/profile.png">
          </b-col>
        </b-row>
        <b-row align-v="center">
          <b-col cols="12" sm="12" md="12" lg="12">
            <p class="sign">Beatiful photography refueled</p>
            <p class="separator">&mdash; &#x2022; &mdash;</p>
          </b-col>
        </b-row>
        <b-row align-v="center">
          <b-col cols="12" sm="12" md="12" lg="12">
            <p class="greetingText">At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id</p>
          </b-col>
        </b-row>
        <b-row class="justify-content-md-center imgCentred">
          <b-col cols="12" sm="12" md="2" lg="2">
            <img src="../assets/img/sign.png">
          </b-col>
        </b-row>

        <b-row class="justify-content-md-center mb-5 cf">
          <b-col cols="2" sm="2" md="1" lg="1" v-for="item in media" :key="item.id">
            <a :href="item.url" :title="item.title"><img :src="item.imgWhite"><img class="top" :src="item.imgHover"></a>
          </b-col>
        </b-row>

        <b-row class="text-center d-sm-flex d-none">
          <b-col cols="12" sm="6" md="6" lg="4" xl="3" align-v="center" v-for="item in items" :key="item.id">
            <div class="card-container">
              <div class="card">
                <div class="side"><img v-img:my-group :src="item.image" :alt="item.alt" class="galleryItem"></div>
                <div class="side back">{{ item.desc }}</div>
              </div>
            </div>
          </b-col>
        </b-row>

        <b-row>
          <b-col cols="12" sm="12" md="12" lg="12" align-v="center" class="imgCentred" style="margin-top: 40px;">
            <router-link to="/Albums" v-on:click="scrollTop()"><div class="button">VIEW ALL WORK</div></router-link>
          </b-col>
        </b-row>

        <b-row align-v="center">
          <b-col cols="12" sm="12" md="12" lg="6" class="imgCentred" style="margin-top: 40px;">
            <img src="../assets/img/flowers.png" style="width: 100%;">
          </b-col>
          <b-col cols="12" sm="12" md="12" lg="6" class="imgCentred" style="margin-top: 40px;">
            <p class="sign text-left">Best Photogrpaher For Wedding Events</p>
            <p class="description" style="text-align: left;">At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in</p>
            <p class="description" style="text-align: left;">Culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga. Eimpedit quo minus id quod maxime placeat facere possimus, omnis voluptas assumenda est, omnis dolor repellendus. Temporibus autem</p>
            <router-link to="/Master" v-on:click="scrollTop()"><div class="button leftSide">READ MORE</div></router-link>
          </b-col>
        </b-row>

        <b-row align-v="center">
          <b-col cols="12" sm="12" md="12" lg="12">
            <p class="sign">Our philosophy</p>
            <p class="separator">&mdash; &#x2022; &mdash;</p>
          </b-col>
        </b-row>

        <b-row align-v="center">
          <b-col cols="12" sm="12" md="12" lg="6" align-v="center" class="imgCentred" style="margin-top: 40px;">
            <p class="sign text-left">Best solution  for any event</p>
            <p class="description" style="text-align: left;">At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga. Et harum quidem rerum facilis est et</p>
            <p class="description" style="text-align: left;">Expedita distinctio. Nam libero tempore, cum soluta nobis est eligendi optio cumque nihil impedit quo minus id quod maxime placeat facere possimus, omnis voluptas assumenda est,</p>
            <p class="description" style="text-align: left;">At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga. Et harum quidem rerum facilis est et</p>
            <router-link to="/Service" v-on:click="scrollTop()"><div class="button leftSide">READ MORE</div></router-link>
          </b-col>
          <b-col cols="12" sm="12" md="12" lg="6" class="imgCentred" style="margin-top: 40px;">
            <img src="../assets/img/photographer.png" style="width: 100%;">
          </b-col>
        </b-row>
    </b-container>
    <b-container fluid class="d-md-inline-block d-none">
      <b-row>
        <div class="embed-responsive embed-responsive-4by3">
          <article class="embed-responsive-item">
            <h1 class="videoSign">Mikes Photography<br /> <span>(Made by <a href="#" target="_blank">Mike B</a>, for <a href="#">ExtraVision</a>)</span></h1>
          </article>
          <video autoplay loop id="video-background" muted plays-inline class="embed-responsive-item">
            <source src="https://player.vimeo.com/external/158148793.hd.mp4?s=8e8741dbee251d5c35a759718d4b0976fbf38b6f&profile_id=119&oauth2_token_id=57447761" type="video/mp4">
          </video>
        </div>
      </b-row>
    </b-container>
    </div>
  </div>
 </transition> 
</template>

<script>
import { Slider, SliderItem } from 'vue-easy-slider'
export default {
  data () {
    return {
      items: [
        {image: require('../assets/img/photo1.png'), alt: 'alt1', desc: 'Opis 1'},
        {image: require('../assets/img/photo2.png'), alt: 'alt2', desc: 'Opis 2'},
        {image: require('../assets/img/photo3.png'), alt: 'alt3', desc: 'Opis 3'},
        {image: require('../assets/img/photo4.png'), alt: 'alt4', desc: 'Opis 4'},
        {image: require('../assets/img/photo5.png'), alt: 'alt5', desc: 'Opis 5'},
        {image: require('../assets/img/photo6.png'), alt: 'alt6', desc: 'Opis 6'},
        {image: require('../assets/img/photo7.png'), alt: 'alt7', desc: 'Opis 7'},
        {image: require('../assets/img/photo8.png'), alt: 'alt8', desc: 'Opis 8'},
        {image: require('../assets/img/photo9.png'), alt: 'alt9', desc: 'Opis 9'},
        {image: require('../assets/img/photo10.png'), alt: 'alt10', desc: 'Opis 10'},
        {image: require('../assets/img/photo11.png'), alt: 'alt11', desc: 'Opis 11'},
        {image: require('../assets/img/photo12.png'), alt: 'alt12', desc: 'Opis 12'},
        {image: require('../assets/img/photo13.png'), alt: 'alt13', desc: 'Opis 13'},
        {image: require('../assets/img/photo14.png'), alt: 'alt14', desc: 'Opis 14'},
        {image: require('../assets/img/photo15.png'), alt: 'alt15', desc: 'Opis 15'},
        {image: require('../assets/img/photo16.png'), alt: 'alt16', desc: 'Opis 16'}
      ],
      list: [
        { backgroundColor: '#000000', width: '100%' },
        { backgroundColor: '#eee', width: '100%' },
        { backgroundColor: '#f44336', width: '100%' }
      ],
      media: [
        { url: 'https://www.facebook.com/', title: 'facebook', imgWhite: require('../assets/img/fbWhite.png'), imgHover: require('../assets/img/fbHover.png') },
        { url: 'https://twitter.com/', title: 'tweeter', imgWhite: require('../assets/img/tweeterWhite.png'), imgHover: require('../assets/img/tweeterHover.png') },
        { url: 'https://plus.google.com/discover', title: 'google plus', imgWhite: require('../assets/img/googleWhite.png'), imgHover: require('../assets/img/googleHover.png') },
        { url: 'http://hexagon.com/news/social-media', title: 'hexagon', imgWhite: require('../assets/img/hexagonWhite.png'), imgHover: require('../assets/img/hexagonWhite.png') },
        { url: 'https://pl.pinterest.com/', title: 'pinterest', imgWhite: require('../assets/img/picsaWhite.png'), imgHover: require('../assets/img/pinterestHover.png') },
        { url: 'https://github.com/features', title: 'github', imgWhite: require('../assets/img/gitWhite.png'), imgHover: require('../assets/img/gitWhite.png') }
      ],
      show: true
    }
  },
  components: {
    Slider,
    SliderItem
  },
  methods: {
    scrollTop () {
      this.$(window).scrollTop(0)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.card {
    border: 0px !important;
  }
  /* These just style the content */
article {
/*  just a fancy border  */
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: 10px;
  z-index: 100;
}

h1 {
  position: absolute;
  top: 60%;
  width: 100%;
  font-size: 36px;
  letter-spacing: 3px;
  color: #fff;
  font-family: Oswald, sans-serif;
  text-align: center;
}

h1 span {
  font-family: sans-serif;
  letter-spacing: 0;
  font-weight: 300;
  font-size: 16px;
  line-height: 24px;
}

h1 span a {
  color: #fff;
}

  .cf img {
    position:absolute;
    left:0;
    -webkit-transition: opacity 1s ease-in-out;
    -moz-transition: opacity 1s ease-in-out;
    -o-transition: opacity 1s ease-in-out;
    transition: opacity 1s ease-in-out;
  }

  .cf img.top:hover {
    opacity:0;
  }

  div.button {
    width: 145px;
    border: 0;
    background: #303030;
    border-radius: 4px;
    color: #fff;
    cursor: pointer;
    font: inherit;
    font-size: 13px;
    margin: 0 auto;
    outline: 0;
    padding: 12px 20px;
    transition: all .1s linear;
  }
  div.button:active {
    transform: translateY(3px);
  }

  .leftSide {
    margin-left: 0px !important;
  }

  @media only screen and (max-width: 768px) {
    .leftSide {
    margin-left: auto !important;
    }
  }

  .card-container {
    cursor: pointer;
    height: 270px;
    perspective: 600;
    position: relative;
    width: 270px;
  }
  .card {
    height: 100%;
    position: absolute;
    transform-style: preserve-3d;
    transition: all 1s ease-in-out;
    width: 100%;
  }
  .card:hover {
    transform: rotateY(180deg);
  }
  .card .side {
    backface-visibility: hidden;
    border-radius: 6px;
    height: 100%;
    position: absolute;
    overflow: hidden;
    width: 100%;
  }
  .card .back {
    background: #eaeaed;
    color: #0087cc;
    line-height: 150px;
    text-align: center;
    transform: rotateY(180deg);
  }

  .fade-enter-active, .fade-leave-active {
    transition: opacity 2s
  }
  .fade-enter, .fade-leave-active {
    opacity: 0
  }

  .separator {
    text-align: center;
    color: #e8e8e8;
  }
  .imgCentred {
    text-align: center!important;
    margin-bottom: 20px;
  }
  .textCentred {
    text-align: center!important;
  }
  .content {
    background-color: #ffffff;
  }
  .sign {
    font-family: 'Playfair Display', serif;
    font-size: 30px;
    font-style: italic;
    text-align: center;
    margin-top: 15px;
  }
  .greetingText {
    font-family: 'Raleway Medium', serif;
    font-size: 12px;
    font-style: italic;
    text-align: center;
  }

  .description {
    font-family: 'Raleway Medium', serif;
    font-size: 12px;
    text-align: center;
  }

  .galleryItem {
    margin-top: 15px;
    margin-right: 5px;
    margin-left: 5px;
    text-align: center;
  }
  
  .slider {
    height: 1096px;
    width: 100%;
  }
  .slider-indicator-icon {
    background-color: rgba(13,12,12,0);
  }
  @media only screen and (max-width: 1440px) {
    .slider {
      height: 822px !important;
      width: 100%;
    }
    img.sliderImage {
      height: 822px;
    }
  }
  @media only screen and (max-width: 1024px) {
    .slider {
      height: 585px !important;
      width: 100%;
    }
    img.sliderImage {
      height: 585px;
    }
  }
  @media only screen and (max-width: 768px) {
    .slider {
      height: 438px !important;
      width: 100%;
    }
    img.sliderImage {
      height: 438px;
    }
    .videoSign {
      font-size: 36px;
    }
  }
  @media only screen and (max-width: 425px) {
    .slider {
      height: 243px !important;
      width: 100%;
    }
    img.sliderImage {
      height: 243px;
    }
    .videoSign {
      font-size: 20px;
    }
  }
  @media only screen and (max-width: 375px) {
    .slider {
      height: 214px !important;
      width: 100%;
    }
    img.sliderImage {
      height: 214px;
    }
    .videoSign {
      font-size: 18px;
    }
  }
  @media only screen and (max-width: 320px) {
    .slider {
      height: 183px !important;
      width: 100%;
    }
    img.sliderImage {
      height: 183px;
    }
    .videoSign {
      font-size: 20px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Hello.vue?34906150